//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getLensTechnologies } from '~/constants/lensTechnologies'

export default {
  props: {
    sku: { type: String, default: '' },
    lensSku: { type: String, default: '' },
    lensTechSelected: { type: Boolean, required: true },
    expanded: { type: Boolean, default: false },
    showWarning: { type: Boolean, default: false }
  },
  computed: {
    options () {
      return getLensTechnologies(this.$ld)
    },
    currentTech () {
      return this.$store.getters['product/lensTech'](this.lensSku)
    },
    activeOption () {
      return this.options.find(option => option.tech === this.currentTech) || {}
    },
    priceWithoutLenses () {
      return this.$store.getters['product/priceFromSku'](this.sku) - this.prices[this.currentTech]
    },
    prices () {
      return this.$store.getters['product/lensTechPrices']((this.lensSku || '').split('_')[0])
    },
    optionsWithDetails () {
      // Get altered SKU for each option
      return this.options.map((option) => {
        const lensSku = this.$store.getters['product/changeLensTech'](this.lensSku || '', option.tech)
        const sku = this.$store.getters['product/changeLensTech'](this.sku || '', option.tech)
        const optionExists = lensSku in this.$store.getters['product/allChoices']
        const preorder = this.$store.getters['product/isOnPreorder'](lensSku) && this.lensTechSelected
        const inStock = (this.$store.getters['product/isInStock'](lensSku) && !preorder) || !this.lensTechSelected
        const price = this.prices[option.tech] + this.priceWithoutLenses

        return {
          lensSku,
          sku,
          disabled: !optionExists || (!inStock && !preorder),
          preorder,
          price,
          inStock,
          ...option
        }
      }).filter(option => option.price) // If no price can be determined then this tech isn't available
    },
    classes () {
      return {
        LensTechSelect: true,
        'LensTechSelect--expanded': this.expanded,
        'LensTechSelect--reduced-options': this.optionsWithDetails.length < 4
      }
    }
  },
  methods: {
    change (option) {
      if (option.disabled) return
      this.$emit('change', option.lensSku)
    }
  }
}
